import './style.scss';

import DoubleBackButtonComponent from './components/back-button';
import CustomInputDropdownComponent from './components/custom-input-dropdown';
import CustomFormInputButtonComponent from './components/form-input-button/form-input-button';
import ItemBoxComponent from './components/item-box';
import ItemSelectComponent from './components/item-select';
import LoadingComponent from './components/loading';
import CustomProgressBarComponent from './components/progress-bar/progress-bar';
import CustomProgressIndicatorComponent from './components/progress-indicator';
import ShoppingCartComponent from './components/shopping-cart';
import CustomSpinnerComponent from './components/spinner/spinner';
import gtmService from './services/gtm/gtm';
import triggerSflEventService from './services/gtm/trigger-sfl-event';
import languageService from './services/language';
import mapAgentContentService from './services/map-agent-content';
import policyDurationService from './services/policy-duration-service';
import policyEndDateService from './services/policy-end-date-service';
import policyStartDateService from './services/policy-start-date-service';
import policyEndDateHumanEmptyService from './services/policy_end_date_human_empty_service';
import accessPinFlagTransformer from './transformers/access-pin-flag';
import addItemTransformer from './transformers/add-item';
import additionalTheftLuggageTransformer from './transformers/additional-theft-luggage';
import autoscrollTransformer from './transformers/autoscroll';
import cleatItemFlagsTransformer from './transformers/clear-item-flags';
import closeLeadPopupTransformer from './transformers/close-lead-popup';
import closeModalRemoveItemTransformer from './transformers/close-modal-remove-item';
import coverageBuildingsFormTrue from './transformers/coverage-buildings-form-true';
import existingInsuranceDefaultValue from './transformers/existing-insurance-default-value';
import fireCoverageBuildingsTransformer from './transformers/fire-coverage-buildings';
import fireCoverageContentsTransformer from './transformers/fire-coverage-contents';
import fireCoverageContentsTrue from './transformers/fire-coverage-contents-true';
import fireWaterCoverageDefaulValue from './transformers/fire-water-coverage-default-value';
import fireWaterCoverageValue from './transformers/fire-water-coverage-value';
import footerTotalPriceTransformer from './transformers/footer-total-price';
import insureItemFlags from './transformers/insured-item-flags';
import insuredSumQuotesTransformer from './transformers/insured-sum-quotes';
import itemsOrderTransformer from './transformers/items-order';
import nameInputsTransformer from './transformers/name-inputs';
import personalInfoTransformer from './transformers/personal-info';
import personsHumanTransformer from './transformers/persons-human';
import policyStartMonthTransformer from './transformers/policy-start-month';
import postcodeChangedFlag from './transformers/postcode-changed-flag';
import prefillAddressTransformer from './transformers/prefill-address';
import primaryColorTransformer from './transformers/primary-color';
import removeItemTransformer from './transformers/remove-item';
import roomsHumanTransformer from './transformers/rooms-human';
import shoppingCartItemsTransformer from './transformers/shopping-cart-items';
import shoppingCartItemsPriceTransformer from './transformers/shopping-cart-items-price';
import insuredSumHrTransformer from './transformers/suggested-insured-sum-hr';
import initialValidator from './validators/initial';
import maxPersonsValidator from './validators/max_persons';

window.registerKaskoPlugin('kasko-plugin', (kasko) => {
  CustomProgressIndicatorComponent.prototype.kasko = kasko;
  CustomProgressBarComponent.prototype.kasko = kasko;
  LoadingComponent.prototype.kasko = kasko;
  ShoppingCartComponent.prototype.kasko = kasko;
  ItemBoxComponent.prototype.kasko = kasko;
  CustomInputDropdownComponent.prototype.kasko = kasko;
  ItemSelectComponent.prototype.kasko = kasko;
  DoubleBackButtonComponent.prototype.kasko = kasko;
  CustomFormInputButtonComponent.prototype.kasko = kasko;
  CustomSpinnerComponent.prototype.kasko = kasko;
  languageService(kasko);
  prefillAddressTransformer(kasko);
  personsHumanTransformer(kasko);
  roomsHumanTransformer(kasko);
  shoppingCartItemsTransformer(kasko);
  shoppingCartItemsPriceTransformer(kasko);
  footerTotalPriceTransformer(kasko);
  primaryColorTransformer(kasko);
  removeItemTransformer(kasko);
  closeModalRemoveItemTransformer(kasko);
  insuredSumHrTransformer(kasko);
  closeLeadPopupTransformer(kasko);
  insuredSumQuotesTransformer(kasko);
  autoscrollTransformer(kasko);
  policyStartMonthTransformer(kasko);
  personalInfoTransformer(kasko);
  nameInputsTransformer(kasko);
  cleatItemFlagsTransformer(kasko);
  insureItemFlags(kasko);
  itemsOrderTransformer(kasko);
  fireWaterCoverageDefaulValue(kasko);
  fireWaterCoverageValue(kasko);
  addItemTransformer(kasko);
  existingInsuranceDefaultValue(kasko);
  fireCoverageBuildingsTransformer(kasko);
  fireCoverageContentsTransformer(kasko);
  accessPinFlagTransformer(kasko);
  additionalTheftLuggageTransformer(kasko);
  fireCoverageContentsTrue(kasko);
  postcodeChangedFlag(kasko);
  coverageBuildingsFormTrue(kasko);
  mapAgentContentService(kasko);
  policyEndDateService(kasko);
  policyStartDateService(kasko);
  policyEndDateHumanEmptyService(kasko);
  policyDurationService(kasko);
  gtmService(kasko);
  triggerSflEventService(kasko);

  return {
    validators: [
      {
        name: 'initial_validator',
        validate: initialValidator(kasko),
      },
      {
        name: 'max_persons',
        validate: maxPersonsValidator(kasko),
      },
    ],
    components: [
      {
        type: 'custom-progress-indicator',
        component: CustomProgressIndicatorComponent,
      },
      {
        type: 'custom-progress-bar',
        component: CustomProgressBarComponent,
      },
      {
        type: 'loading-indicator',
        component: LoadingComponent,
      },
      {
        type: 'shopping-cart',
        component: ShoppingCartComponent,
      },
      {
        type: 'item-box',
        component: ItemBoxComponent,
      },
      {
        type: 'custom-input-dropdown',
        component: CustomInputDropdownComponent,
      },
      {
        type: 'item-select',
        component: ItemSelectComponent,
      },
      {
        type: 'double-back-button',
        component: DoubleBackButtonComponent,
      },
      {
        type: 'custom-form-input-button',
        component: CustomFormInputButtonComponent,
      },
      {
        type: 'custom-spinner',
        component: CustomSpinnerComponent,
      },
    ],
  };
});
